import { categoryWidth, categoryNameWidth, categoryCoverageWidth, categoryNameHeaderWidth, categoryCoverageHeaderWidth } from './shared-constant';

const outline = {
  '&[data-activedescendant-focusvisible]': {
    outline: '1px solid #000',
  },
};

export const getButtonInItemStyles = () => ({
  button: {
    ...outline,
    '& span': {
      marginRight: 0,
    },
  },
});

export const getCategorySelectorStyles = () => ({
  root: {
    width: categoryWidth,
    '& [role=heading] .fui-Option__checkIcon': {
      display: 'none',
    },
    '& [role=navigation] .fui-Option__checkIcon': {
      display: 'none',
    },
    // '& [role=listbox]': {
    //   overflow: 'unset !important',
    // },
  },
  pager: {
    '& .page-control': {
      marginLeft: 0,
    },
    '& button': outline,
  },
  footer: {
    // position: 'fixed !important',
    // bottom: 0,
  },
  blocker: {
    display: 'flex',
    flexDirection: 'column',
    // marginBottom: 100,
    // overflowY: 'auto',
    // overflowX: 'hidden',
  },
});

export const getCategorySelectorHeaderStyles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  name: {
    width: categoryNameHeaderWidth,
    '& button + button': {
      paddingLeft: 0,
    },
  },
  coverage: {
    width: categoryCoverageHeaderWidth,
    alignContent: 'space-around',
  },
});


export const getCategorySelectorItemStyles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  name: {
    width: categoryNameWidth,
  },
  coverage: {
    width: categoryCoverageWidth,
    textAlign: 'center',
    alignContent: 'center',
  },
  link: outline,
});
